// extracted by mini-css-extract-plugin
export default {"wrapper":"t1-z","play":"u1-z"};